import { swedishNumberFormatter } from '@fora-monorepo/string-utils';
import { Text } from '@foradevelopment/fora-ui';
import { getReadablePayMonth } from '@fora-monorepo/employer-my-pages-common/utils';

import { useTypedTranslation } from '../../../i18n/i18n';

export const PayMonthSummaryLine = ({
  payMonth,
  numberOfPays,
  totalSum,
}: {
  payMonth: string;
  numberOfPays: number;
  totalSum: number;
}) => {
  const { t } = useTypedTranslation();
  return (
    <>
      <Text style={{ fontSize: '18px' }} fontWeight="semibold">
        {t('modal.reportReceipt.payMonthSummaryLine1', {
          numberOfPays,
          payMonth: getReadablePayMonth(payMonth),
        })}
      </Text>
      <Text marginBottom={16}>
        {t('modal.reportReceipt.payMonthSummaryLine2', {
          totalSum: swedishNumberFormatter(totalSum),
        })}
      </Text>
    </>
  );
};
